export enum UserAction {
  InsertComponentFromDiscover = 'InsertComponentFromDiscover',
  InsertBlueprintFromDiscover = 'InsertBlueprintFromDiscover',
  CloseDiscoverWithoutContentInserted = 'CloseDiscoverWithoutContentInserted',
  InsertActivityBlueprintFromDiscover = 'InsertActivityBlueprintFromDiscover',
  TimeToRenderDiscover = 'TimeToRenderDiscover'
}
